import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import styled from "styled-components";

type Props = {
  key?: string;
  handleChange: (selectedItem: any) => any;
  itemList?: any[];
  itemDict?: { [key: string | number]: any };
  label: string;
  nameKey?: string;
  defaultValue?: string | number;
  unselected?: boolean;
  width?: number;
  reset?: boolean;
};

const SelectItem = (props: Props) => {
  const [selectedKey, setSelectedKey] = useState(
    props.defaultValue === undefined
      ? -1
      : (props.defaultValue as number | string),
  );
  if (props.reset && selectedKey !== -1) {
    setSelectedKey(-1);
  }
  const [changedFlag, setChangedFlag] = useState(false);

  const onChange = useCallback(
    (key: number | string) => {
      if (props.itemList) {
        const index = typeof key === "string" ? parseInt(key) : key;
        setChangedFlag(true);
        setSelectedKey(index);
        props.handleChange(props.itemList[index]);
      }
      if (props.itemDict) {
        setChangedFlag(true);
        setSelectedKey(key);
        props.handleChange(props.itemDict[key]);
      }
    },
    [props],
  );

  const itemsFromArray = useMemo(() => {
    const items: JSX.Element[] = [];
    if (!props.itemList) {
      return <></>;
    }
    if (
      props.reset ||
      (!changedFlag &&
        props.itemList.length > 0 &&
        (props.defaultValue === undefined ||
          (typeof props.defaultValue === "number" && props.defaultValue < 0) ||
          (typeof props.defaultValue === "string" &&
            parseInt(props.defaultValue) < 0)))
    ) {
      items.push(
        <MenuItem key={-1} value={-1}>
          --選択してください--
        </MenuItem>,
      );
    }
    props.itemList.forEach((item, index) => {
      items.push(
        <MenuItem key={index} value={index}>
          {props.nameKey ? item[props.nameKey] : item.name}
        </MenuItem>,
      );
    });
    return items;
  }, [changedFlag, props.defaultValue, props.itemList, props.nameKey, props.reset]);

  const itemsFromDict = useMemo(() => {
    const items: JSX.Element[] = [];
    if (!props.itemDict) {
      return <></>;
    }
    if (
      props.reset ||
      (!changedFlag &&
        Object.keys(props.itemDict).length > 0 &&
        props.defaultValue === undefined)
    ) {
      items.push(
        <MenuItem key={-1} value={-1}>
          --選択してください--
        </MenuItem>,
      );
    }
    Object.keys(props.itemDict).forEach((key) => {
      items.push(
        <MenuItem key={key} value={key}>
          {props.itemDict![key][props.nameKey || ""]}
        </MenuItem>,
      );
    });
    return items;
  }, [
    changedFlag,
    props.defaultValue,
    props.itemDict,
    props.nameKey,
    props.reset,
  ]);

  const components = useMemo(
    () => (
      <>
        <InputLabel sx={{ fontWeight: "bold" }}>{props.label}</InputLabel>
        <FormControl
          sx={{
            m: 1,
            width: props.width ? `${props.width}px` : "250px",
            margin: "auto",
          }}
          size="small"
        >
          <Select
            key={`select-${props.key}`}
            variant="standard"
            defaultValue={props.unselected ? -1 : props.defaultValue}
            value={selectedKey}
            label={props.label}
            onChange={(event) => {
              onChange(event.target.value);
            }}
            sx={{
              width: props.width ? `${props.width}px` : "250px",
              margin: "auto",
            }}
          >
            {props.itemList ? (
              itemsFromArray
            ) : props.itemDict ? (
              itemsFromDict
            ) : (
              <></>
            )}
          </Select>
        </FormControl>
      </>
    ),
    [itemsFromArray, itemsFromDict, onChange, props.defaultValue, props.itemDict, props.itemList, props.key, props.label, props.unselected, props.width, selectedKey],
  );

  return <SelectItemStyle>{components}</SelectItemStyle>;
};

const SelectItemStyle = styled.div`
  margin: 10px auto 10px auto;
`;

export default SelectItem;
